import type FetchValidationRulesConfig from '@modules/store/common/types/FetchValidationRulesConfig.entity';
import { validateNorwegianIdNumber } from 'norwegian-national-id-validator';

export function addNORValidationRules(config: FetchValidationRulesConfig): void {
  config.extendRule('ssn', {
    params: ['length'],
    message: (field: string) => {
      return config.translator.t(`${config.translatorProjectPrefix}.validation.{field} is not a valid ssn-number`, {
        field,
      });
    },
    validate: (value: string, { length }: { length: string }) => {
      const SSNwhiteList = ['15823149481', '58907800510', '14118149719', '05026949639', '03107900283', '03117000396'];
      const isValidSSN = validateNorwegianIdNumber(value) || SSNwhiteList.includes(value);
      return isValidSSN && value.length === parseInt(length);
    },
  });
  config.extendRule('length', {
    params: ['length'],
    message: (field: string, { length }: { length: string }): string => {
      return config.translator.t(`${config.translatorProjectPrefix}.validation.{field} length cant exceed more than {length} characters`, {
        field,
        length,
      });
    },
    validate: (value: string, { length }: { length: string }): boolean => {
      return value.length < parseInt(length);
    }
  });
  config.extendRule('english-alphabet', {
    message: (field: string) => {
      return config.translator.t(`${config.translatorProjectPrefix}.validation.{field} can only contain english characters`, {
        field,
      });
    },
    validate: (value: string) => {
      return !value.match(/[æøå]/);
    },
  });
}
